export const ACTIONS = {
  renouvellement: 'renew',
  modification: 'update',
  visibilite: 'upsell',
};
